<template>
  <div class="p-4 shadow transition-all hover:shadow-md">
    <div>
      <div class="font-bold">Lịch sử cập nhật</div>
    </div>
    <div class="w-full">
      <div v-if="isLoading">Đang tải...</div>
      <div v-else>
        <div v-if="updateHistory.length === 0">Không có lịch sử cập nhật.</div>
        <div v-else>
          <div class="overflow-x-auto">
            <table class="table">
              <thead>
                <tr>
                  <th>STT</th>
                  <th>Thời gian</th>
                  <th>Phiên bản</th>
                  <th>Loại</th>
                  <th>Trạng thái</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in updateHistory" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    {{ dayjs(item.created).format("YYYY-MM-DD HH:mm:ss") }}
                  </td>
                  <td>{{ item.version }}</td>
                  <td>{{ item.is_campaign ? "Chiến dịch" : "Máy trạm" }}</td>
                  <td>
                    <span
                      class="badge"
                      :class="
                        item.status === 'pending'
                          ? 'badge-warning'
                          : item.status === 'success'
                            ? 'badge-success'
                            : ''
                      "
                    >
                      {{
                        statusMap[item.status as keyof typeof statusMap] ||
                        item.status
                      }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <PaginationTemplate :total_pages="total_page" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PaginationTemplate from "@/components/PaginationTemplate.vue";
import { useUpdateHistory } from "@/composables/useUpdateHistory";
import dayjs from "dayjs";

const props = defineProps<{
  campaignId: string;
}>();

const statusMap = {
  pending: "Chờ xử lý",
  success: "Thành công",
} as const;

const { isLoading, updateHistory, total_page } = useUpdateHistory({
  agent_id: "",
  campaign_id: props.campaignId,
});
</script>
